const statKeys = ['total', 'sent', 'opened', 'clicked', 'submitted_data', 'email_reported'];

export function campaignDate(value) {
  if (!value || String(value).startsWith('0001-')) return null;
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function localDay(value) {
  const date = value instanceof Date ? value : campaignDate(value);
  if (!date || !Number.isFinite(date.getTime())) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function presetRange(days, now = new Date()) {
  const from = new Date(now);
  from.setDate(from.getDate() - days + 1);
  return { from: localDay(from), to: localDay(now) };
}

export function rangeDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day, 12);
  return localDay(date) === value ? date : null;
}

export function validRange({ from, to }) {
  return !!rangeDate(from) && !!rangeDate(to) && from <= to;
}

export function readCampaigns(response) {
  if (!Array.isArray(response?.campaigns) || response.campaigns.some(item =>
    !Number.isSafeInteger(item?.id) || item.id <= 0 || typeof item.name !== 'string' ||
    !campaignDate(item.created_date) || !statKeys.every(key => typeof item.stats?.[key] === 'number' &&
      Number.isFinite(item.stats[key]) && item.stats[key] >= 0))) {
    throw new Error('Invalid campaign summaries');
  }
  return response.campaigns;
}

export function filterCampaigns(campaigns, range) {
  return campaigns.filter(item => {
    const day = localDay(item.created_date);
    return day && day >= range.from && day <= range.to;
  });
}

export function isScheduled(campaign, now = new Date()) {
  const launch = campaignDate(campaign.launch_date);
  return campaign.status === 'Queued' && !!launch && launch > now;
}

export function campaignTotals(campaigns, now = new Date()) {
  const totals = Object.fromEntries(statKeys.map(key => [key, 0]));
  campaigns.forEach(item => statKeys.forEach(key => { totals[key] += item.stats[key]; }));
  return { ...totals, count: campaigns.length,
    active: campaigns.filter(item => ['In progress', 'Emails Sent'].includes(item.status)).length,
    scheduled: campaigns.filter(item => isScheduled(item, now)).length };
}

export function percentage(count, denominator) {
  return denominator > 0 ? count / denominator * 100 : null;
}

export function trendCampaigns(campaigns, limit = 20) {
  return campaigns.filter(item => item.stats.sent > 0 && campaignDate(item.launch_date))
    .sort((a, b) => campaignDate(a.launch_date) - campaignDate(b.launch_date) || a.id - b.id).slice(-limit);
}
